module.exports = __webpack_public_path__ + "static/img/serviceP3.99c4da99.png";